module.exports = __webpack_public_path__ + "static/media/ElectoratesSocial.c512805a.jpg";